// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".k-grid tr.dragging {background-color: #f45c42;}", "",{"version":3,"sources":["webpack://./src/app/cp/dispatches/labor/dispatch-labor.component.ts"],"names":[],"mappings":"AAAA,qBAAqB,yBAAyB,CAAC","sourcesContent":[".k-grid tr.dragging {background-color: #f45c42;}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
